import { BaseDTO } from "./BaseDTO";

export class TipoIrpfGestionDTO extends BaseDTO {
    codigo?: number;
    porcentaje?: number;
    clave?: string;
    subClave?: string;
}